import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as avLocalStorage from '@availity/localstorage-core';
import qs from 'qs';
import resolveUrl from '@availity/resolve-url';
import API_OPTIONS from './options';

var AvApi =
/*#__PURE__*/
function () {
  function AvApi(_ref) {
    var http = _ref.http,
        promise = _ref.promise,
        merge = _ref.merge,
        config = _ref.config;

    if (!http || !config || !promise || !merge) {
      throw new Error('[http], [promise], [config], and [merge] must be defined');
    }

    this.http = http;
    this.Promise = promise;
    this.merge = merge;
    this.defaultConfig = this.merge({}, API_OPTIONS.API, config);
  } // get the merged config


  var _proto = AvApi.prototype;

  _proto.config = function config(_config) {
    if (_config === void 0) {
      _config = {};
    }

    return this.merge({}, this.defaultConfig, _config);
  };

  _proto.addParams = function addParams(params, config, newObj) {
    if (params === void 0) {
      params = {};
    }

    if (config === void 0) {
      config = {};
    }

    if (newObj === void 0) {
      newObj = true;
    }

    var output = newObj ? _objectSpread({
      params: {}
    }, config) : config;

    if (!newObj) {
      output.params = output.params || {};
    }

    output.params = _objectSpread({}, output.params, {}, params);
    return output;
  } // set the cache parameters
  ;

  _proto.cacheParams = function cacheParams(config) {
    var _this = this;

    var params = {};

    if (config.cacheBust) {
      params.cacheBust = this.getCacheBustVal(config.cacheBust, function () {
        return Date.now();
      });
    }

    if (config.pageBust) {
      params.pageBust = this.getCacheBustVal(config.pageBust, function () {
        return _this.getPageBust();
      });
    }

    if (config.sessionBust) {
      params.sessionBust = this.getCacheBustVal(config.sessionBust, function () {
        return avLocalStorage.getSessionBust() || _this.getPageBust();
      });
    }

    return this.addParams(params, config, false);
  } // get the cache value with default function
  ;

  _proto.getCacheBustVal = function getCacheBustVal(cacheBust, defaultFn) {
    if (!cacheBust) {
      return undefined;
    }

    if (typeof cacheBust === 'boolean' && defaultFn) {
      return defaultFn();
    }

    if (typeof cacheBust === 'function') {
      return cacheBust();
    }

    return cacheBust;
  } // get pagebust value, make sure it is instantiated first
  ;

  _proto.getPageBust = function getPageBust() {
    if (typeof this.pageBustValue === 'undefined') {
      this.setPageBust();
    }

    return this.pageBustValue;
  } // set the page bust value to given value or timestamp
  ;

  _proto.setPageBust = function setPageBust(value) {
    this.pageBustValue = typeof value === 'undefined' ? Date.now() : value;
  } // get final url from config
  ;

  _proto.getUrl = function getUrl(config, id) {
    if (id === void 0) {
      id = '';
    }

    if (!config.api) {
      return config.url;
    }

    var path = config.path,
        version = config.version,
        name = config.name,
        url = config.url;
    var parts = [];

    if (name) {
      parts = ['', path, version, name, id];
    } else {
      parts = [url, id];
    } // join parts, remove multiple /'s and trailing /


    return parts.join('/').replace(/[/]+/g, '/').replace(/\/$/, '');
  };

  _proto.getRequestUrl = function getRequestUrl() {
    return this.getUrl(this.config());
  } // return location if should poll otherwise false
  ;

  _proto.getLocation = function getLocation(response) {
    var locationUrl;
    var config = response.config,
        _response$headers = response.headers,
        headers = _response$headers === void 0 ? {} : _response$headers;
    var getHeader = config.getHeader,
        base = config.base;
    var location = headers.location,
        Location = headers.Location;

    if (getHeader) {
      locationUrl = getHeader(response, 'Location');
    } else {
      locationUrl = location || Location;
    }

    return resolveUrl({
      relative: locationUrl,
      base: base
    });
  } // condition for calls that should continue polling
  ;

  _proto.shouldPoll = function shouldPoll(response) {
    return response && response.config && response.config.polling && response.status === 202 && response.config.attempt < response.config.pollingIntervals.length;
  } // handle response with possible polling
  ;

  _proto.onResponse = function onResponse(response, afterResponse) {
    var _this2 = this;

    if (this.shouldPoll(response)) {
      var newConfig = this.config(response.config);
      var pollingUrl = this.getLocation(response);

      if (pollingUrl) {
        newConfig.method = this.defaultConfig.pollingMethod;
        newConfig.url = pollingUrl;
        newConfig.cache = false;
        return new this.Promise(function (resolve) {
          setTimeout(resolve, newConfig.pollingIntervals[newConfig.attempt] || 1000);
        }).then(function () {
          return _this2.request(newConfig, afterResponse);
        });
      }
    }

    return afterResponse ? afterResponse(response) : response;
  } // make request to http
  ;

  _proto.request = function request(config, afterResponse) {
    var _this3 = this;

    if (config.polling) {
      config.attempt = config.attempt || 0;
      config.attempt += 1;
    }

    return this.http(config).then(function (response) {
      return _this3.onResponse(response, afterResponse);
    });
  } // post request
  ;

  _proto.create = function create(data, config) {
    if (!data) {
      throw new Error('called method without [data]');
    }

    config = this.config(config);
    config.method = 'POST';
    config.url = this.getUrl(config);
    config.data = data;
    var beforeFunc = this.beforeCreate || this.beforePost;

    if (beforeFunc) {
      config.data = beforeFunc(config.data);
    }

    return this.request(config, this.afterCreate || this.afterPost);
  };

  _proto.post = function post(data, config) {
    return this.create(data, config);
  } // post request with method-override to get
  ;

  _proto.postGet = function postGet(data, config) {
    if (!data) {
      throw new Error('called method without [data]');
    }

    config = this.config(config);
    config.method = 'POST';
    config.headers = config.headers || {};
    config.headers['X-HTTP-Method-Override'] = 'GET';
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/x-www-form-urlencoded';
    config.url = this.getUrl(config);
    config.data = data;

    if (this.beforePostGet) {
      config.data = this.beforePostGet(config.data);
    }

    if (typeof config.data !== 'string' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data, {
        encode: false,
        arrayFormat: 'repeat',
        indices: false,
        allowDots: true
      });
    }

    return this.request(config, this.afterPostGet);
  } // get request with id
  ;

  _proto.get = function get(id, config) {
    if (!id) {
      throw new Error('called method without [id]');
    }

    config = this.config(config);
    config.method = 'GET';
    config.url = this.getUrl(config, id);
    config = this.cacheParams(config);
    return this.request(config, this.afterGet);
  } // get request with just params
  ;

  _proto.query = function query(config) {
    config = this.config(config);
    config.method = 'GET';
    config.url = this.getUrl(config);
    config = this.cacheParams(config);
    return this.request(config, this.afterQuery);
  };

  _proto.all = function all(config) {
    var _this4 = this;

    return this.query(config).then(function (resp) {
      var key = _this4.getQueryResultKey(resp.data);

      var totalPages = Math.ceil(resp.data.totalCount / resp.data.limit);
      var result = resp.data[key] || [];

      if (totalPages > 1) {
        var otherPages = [];

        for (var i = 0; i < totalPages - 1; i += 1) {
          otherPages[i] = i + 2;
        }
        /* eslint-disable promise/no-nesting */


        return _this4.Promise.all(otherPages.map(function (page) {
          return _this4.getPage(page, config, resp.data.limit).then(function (pageResp) {
            return pageResp.data[key] || [];
          });
        })).then(function (pages) {
          return result.concat.apply(result, _toConsumableArray(pages));
        });
      }

      return result;
    });
  };

  _proto.getQueryResultKey = function getQueryResultKey(data) {
    return Object.keys(data).filter(function (key) {
      return Array.isArray(data[key]);
    })[0];
  };

  _proto.getResult = function getResult(data) {
    return data[this.getQueryResultKey(data)];
  };

  _proto.getPage = function getPage(page, config, limit) {
    if (page === void 0) {
      page = 1;
    }

    if (config === void 0) {
      config = {};
    }

    limit = limit || config.params && config.params.limit || 50;
    var offset = (page - 1) * limit;
    return this.query(this.addParams({
      offset: offset,
      limit: limit
    }, config, false));
  } // put request
  ;

  _proto.update = function update(id, data, config) {
    if (typeof id !== 'string' && typeof id !== 'number') {
      config = data;
      data = id;
      id = '';
    }

    config = this.config(config);
    config.method = 'PUT';
    config.url = this.getUrl(config, id);
    config.data = data;
    var beforeFunc = this.beforeUpdate || this.beforePut;

    if (beforeFunc) {
      config.data = beforeFunc(config.data);
    }

    return this.request(config, this.afterUpdate || this.afterPut);
  };

  _proto.put = function put() {
    return this.update.apply(this, arguments);
  } // delete request
  ;

  _proto.remove = function remove(id, config) {
    if (typeof id !== 'string' && typeof id !== 'number') {
      config = id;
      id = '';
    }

    config = this.config(config);
    config.method = 'DELETE';
    config.url = this.getUrl(config, id);
    var beforeFunc = this.beforeRemove || this.beforeDelete;

    if (beforeFunc) {
      config = beforeFunc(config);
    }

    return this.request(config, this.afterRemove || this.afterDelete);
  };

  _proto["delete"] = function _delete() {
    return this.remove.apply(this, arguments);
  };

  return AvApi;
}();

export { AvApi as default };